import { getAnnuityFactor } from "shared/getAnnuityFactor";

export const mortgageFromPayment = (
	payment: number,
	rate: number,
	months: number,
) => Math.round(payment * getAnnuityFactor(rate / 12, months));
